// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { INTEGRATION_NAME } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { integrationSettingsUrl } from 'automation-ui-references/routing/hubspotUrls';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <IntegrationName id="123" />
 * Renders as:
 *   My Test App
 */
const IntegrationName = ({
  id,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  href: href || integrationSettingsUrl(),
  id: id,
  messageKey: messageKey,
  referenceObjectType: INTEGRATION_NAME
});
export default IntegrationName;